<template>
  <div class="account-pages mt-3">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5 text-muted">
            <p>Lei Geral de Proteção de Dados</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <b-alert show dismissible variant="danger" v-if="alert.erro">
            <template v-if="Array.isArray(msg.erro)">
              <ul class="mb-0">
                <li v-for="(err, index) in msg.erro" :key="index">
                  {{ typeof err === 'string' ? err : err.message }}
                </li>
              </ul>
            </template>

            <template v-else-if="msg.errors && Array.isArray(msg.errors)">
              <p class="mb-1">{{ msg.message }}</p>
              <ul class="mb-0">
                <li v-for="(err, index) in msg.errors" :key="'e' + index">{{ err }}</li>
              </ul>
            </template>

            <template v-else>
              {{ msg.erro || msg.message || 'Ocorreu um erro inesperado.' }}
            </template>
          </b-alert>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card" :class="{
            'is-not-valide-code': alert.erro,
          }">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-avatar">
                      <i class="color-avatar bx bxs-envelope h1 mb-0"></i>
                    </div>
                  </div>
                  <div class="p-2 mt-4">
                    <h4>Verifique seu E-mail</h4>
                    <p class="mb-3">
                      Confirme o código mandado ao e-mail:
                      <span class="fw-semibold"><b>{{ email }}</b></span>
                    </p>
                    <div>

                      <CustomCodeInput
                        :length="6"
                        ref="codeInput"
                        :autoFocus="true"
                        @complete="onComplete"
                        @change="onCodeChange"
                      />
                    </div>
                    <div class="mt-4">
                      <div class="button-items">
                        <b-button size="lg" variant="success" type="buttton" @click="onConfirmCodeSubmit()">
                          Confirme
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 text-center">
            <p>
              Não recebeu o e-mail?<a href="#" @click="reenviarCodeEmail()">
                Clique aqui
              </a>
            </p>
          </div>
          <div class="mt-5 text-center">
            <p>
              © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import CustomCodeInput from "./CustomCodeInput.vue";

export default {
  props: {
    email: String,
    errosExternos: {
      type: Array,
      default: () => [],
    },
  },
  page: {
    title: "Confirme codigo e-mail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { CustomCodeInput },
  data() {
    return {
      codeEmailConfirm: '',
      msg: {
        erro: [],
      },
      alert: {
        erro: false,
      },
    };
  },

  mounted() {
    this.focusCodeInput();
  },

  watch: {
    errosExternos(newErrors) {
      if (newErrors.length > 0) {
        this.alert.erro = true;
        this.msg.erro = newErrors;
      }
    },
  },
  methods: {
    onComplete(code) {
      this.codeEmailConfirm = code;
    },

    onCodeChange(code) {
      this.codeEmailConfirm = code;
    },

    onConfirmCodeSubmit() {
      if (this.codeEmailConfirm.length < 6) {
        alert('Por favor, digite o código completo de 6 dígitos');
        this.focusCodeInput();
        return;
      }

      this.alert.erro = false;
      this.msg.erro = [];

      this.$http
        .post("api/lgpd/confirme-code", {
          email: this.email,
          code: this.codeEmailConfirm,
        })
        .then(() => {
          this.alert.erro = false;
          this.msg.erro = [];
          this.$parent.onSubmit();
        })
        .catch((err) => {
          this.alert.erro = true;
          this.msg.erro.push(err.response.data);
          this.$parent.isConfirmCodeEmail = true;
        });
    },
    reenviarCodeEmail() {
      this.$parent.mandaEmailCodeConfirme();
    },

    focusCodeInput() {
      if (this.$refs.codeInput && this.$refs.codeInput.focusInput) {
        this.$refs.codeInput.focusInput(0);
      }
    },
  },
};
</script>


<style scoped>
.bg-avatar {
  background-color: #d5e5fa !important;
}

.color-avatar {
  color: #2c7be5 !important;
}
.is-not-valide-code {
  animation: nono 500ms, fade paused;
}

@keyframes nono {

  0%,
  100% {
    transform: translateX(0);
  }

  20%,
  60% {
    transform: translateX(-5%);
  }

  40%,
  80% {
    transform: translateX(5%);
  }
}
</style>
